// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T7OK","left":"styles_left__uOS5m"};